<!-- @format -->

<template>
	<div v-if="data.length > 0" class="reply-box">
		<div class="reply-list">
			<ContentBox
				v-for="(reply, index) in data.list"
				:id="id"
				:key="index"
				:data="reply"
				reply
				:disabled-reply="disabledReply"
			></ContentBox>
			<div v-if="data.length > replyShowSize" class="fetch-more">
				<div v-if="!state.over">
					还有{{ data.total - replyShowSize }}条回复,
					<span class="fetch-more-comment select-none" @click="replyMore">
						点击查看
						<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="">
							<path
								data-v-d6f79dbc=""
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M5.99976 7.93206L10.0656 3.86619C10.1633 3.76856 10.3215 3.76856 10.4192 3.86619L10.7727 4.21975C10.8704 4.31738 10.8704 4.47567 10.7727 4.5733L6.35331 8.99272C6.15805 9.18798 5.84147 9.18798 5.6462 8.99272L1.22679 4.5733C1.12916 4.47567 1.12916 4.31738 1.22679 4.21975L1.58034 3.86619C1.67797 3.76856 1.83626 3.76856 1.93389 3.86619L5.99976 7.93206Z"
							></path>
						</svg>
					</span>
				</div>
			</div>
			<div v-if="state.over && page" class="fetch-more">
				<el-pagination
					small
					hide-on-single-page
					layout="total, prev, pager, next"
					:total="data.total"
					:page-size="state.pageSize"
					@current-change="currentChange"
					@size-change="sizeChange"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import ContentBox from './content-box.vue';

	interface Props {
		data?: any;
		id: string;
		disabledReply: boolean;
	}

	const props = defineProps<Props>();
	const state = reactive({
		over: false,
		pageNum: 1,
		pageSize: 5,
	});

	const { replyPage, replyShowSize, comments, page, isFrontPage } = inject('InjectReplyBox') as any;

	// 分页操作
	const data = computed(() => {
		let data = {
			total: 0,
			length: 0,
			list: [] as any[],
		};
		if (props.data) {
			const length = props.data.list.length;
			data = {
				total: props.data.total,
				length,
				list: props.data.list,
			};
		}
		if (!state.over) {
			const tmp = data.list.slice(0, replyShowSize);
			data.list = tmp;
		}
		if (page) {
			if (isFrontPage) {
				const skipNum = (state.pageNum - 1) * state.pageSize;
				const newArr =
					skipNum + state.pageSize >= data.list.length
						? data.list.slice(skipNum, data.list.length)
						: data.list.slice(skipNum, skipNum + state.pageSize);
				data.list = newArr;
			} else {
				data.list = data.list.slice(0, 5);
			}
		}
		return data;
	});

	const replyMore = () => {
		state.over = true;
	};

	const finish = (val: any) => {
		if (!isFrontPage) {
			comments.value.forEach((e) => {
				if (e.id == props.id) {
					if (e.reply) {
						e.reply = val;
					}
				}
			});
		}
	};

	const currentChange = (val: number) => {
		state.pageNum = val;
		replyPage(props.id, val, state.pageSize, (reply) => finish(reply));
	};

	const sizeChange = (val: number) => {
		state.pageSize = val;
		replyPage(props.id, state.pageNum, val, (reply) => finish(reply));
	};
</script>

<style lang="scss" scoped>
	.reply-box {
		margin-top: 10px;
		background: #f7f7f7;
		color: #606266;

		.el-pagination {
			--el-pagination-button-disabled-bg-color: none;
			--el-pagination-bg-color: none;
			padding: 0;
		}

		.reply-list {
			padding: 10px;
			border-radius: 4px;
		}

		.fetch-more {
			margin-left: 36px;
			margin-top: 10px;
			color: #6d757a;
			font-size: 12px;
			line-height: 22px;

			.fetch-more-comment {
				color: var(--el-color-primary);
				box-sizing: border-box;
				cursor: pointer;

				svg {
					fill: currentColor;
					margin-bottom: 3px;
				}
			}
		}
	}
</style>
